import React, { useState, useEffect } from 'react';
import CustomNavbar from '../components/Navbar';
import Counters from './Counters';
import Profile from './Profile';
import PartnerPreferences from './PartnerPreferences';
import ManagePhotos from './ManagePhotos';
import Verifications from './Verifications';
import { Tabs } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useProfile } from '../context/ProfileContext';




const Dashboard = () => {
	const [navbarReady, setNavbarReady] = useState(false);
	const location = useLocation();
	const navigate = useNavigate();
	const [activeKey, setActiveKey] = useState('1');
	const { profileId, firstName: profileFirstName } = useProfile();

	useEffect(() => {
		if (navbarReady) {
			if (location.pathname === '/dashboard') {
				setActiveKey('1');
			} else if (location.pathname === '/my-profile') {
				setActiveKey('2');
			} else if (location.pathname === '/partner-preferences') {
				setActiveKey('3');
			} else if (location.pathname === '/manage-photos') {
				setActiveKey('4');
			} else if (location.pathname === '/verifications') {
				setActiveKey('5');
			}
		}
	}, [navbarReady, location.pathname]);

	const handleTabChange = (key) => {
		if (key === '1') {
			navigate('/dashboard');
		} else if (key === '2') {
			navigate('/my-profile');
		} else if (key === '3') {
			navigate('/partner-preferences');
		} else if (key === '4') {
			navigate('/manage-photos');
		} else if (key === '5') {
			navigate('/verifications');
		}
	};

	const tabItems = [
		{
			key: '1',
			label: 'Dashboard',
			children: (
				<div>
					<div style={{
						textAlign: 'center',
						marginBottom: '24px',
						padding: '20px 16px 0',
					}}>
						<div style={{
							display: 'inline-block',
							background: 'linear-gradient(135deg, #AD1457, #D81B60)',
							WebkitBackgroundClip: 'text',
							WebkitTextFillColor: 'transparent',
							backgroundClip: 'text',
							fontSize: '1.6rem',
							fontWeight: '800',
							letterSpacing: '-0.3px',
						}}>
							Welcome back, {profileFirstName}!
						</div>
						<div style={{ color: '#64748B', fontSize: '0.9rem', marginTop: '4px' }}>
							Here's an overview of your activity
						</div>
					</div>
					{navbarReady && profileId && <Counters profileId={profileId} />}
				</div>
			),
		},
		{
			key: '2',
			label: 'My Profile',
			children: <Profile viewProfileId={profileId} />,
		},
		{
			key: '3',
			label: 'Partner Preferences',
			children: <PartnerPreferences />,
		},
		{
			key: '4',
			label: 'Manage Photos',
			children: <ManagePhotos />,
		},
		{
			key: '5',
			label: 'Verifications',
			children: <Verifications />,
		},
	];

	useEffect(() => {
		const titles = {
			'/dashboard': 'Dashboard',
			'/my-profile': 'My Profile',
			'/partner-preferences': 'Partner Preferences',
			'/manage-photos': 'Manage Photos',
			'/manage-profiles': 'Manage Profiles',
			'/verifications': 'Verifications',
		};
		document.title = `${titles[location.pathname] ?? 'Dashboard'} | Oottan`;
	}, [location.pathname]);

	return (
		<div style={{ fontFamily: 'Calibri, sans-serif' }}>
			<CustomNavbar onNavbarReady={() => setNavbarReady(true)} />
			<div className="dashboard-wrapper">
				<div style={{ maxWidth: '1200px', margin: '0 auto', padding: '24px 16px' }}>
					<Tabs activeKey={activeKey} onChange={handleTabChange} centered items={tabItems} />
				</div>
			</div>
		</div>
	);
};

export default Dashboard;